import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import {
	IssueAdjustmentsAsync,
	type IssueAdjustmentsAsyncProps,
} from '@atlassian/jira-issue-adjustments/src/ui/uim-root-async/index.tsx';
import { getAnalyticsWebClientPromise } from '@atlassian/jira-product-analytics-web-client-async';
import { useActivationId } from '@atlassian/jira-tenant-context-controller/src/components/activation-id/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { AnalyticsListener } from '@atlassian/ui-modifications-analytics';

export type UiModificationsJiraCoreProps = Omit<
	IssueAdjustmentsAsyncProps,
	'cloudId' | 'activationId'
>;

export const UiModificationsJiraCore = (props: UiModificationsJiraCoreProps) => {
	const cloudId = useCloudId();
	const activationId = useActivationId();

	if (fg('analytics-replace-jira-packages')) {
		return (
			<AnalyticsListener
				analyticsWebClient={getAnalyticsWebClientPromise().then((client) => client.getInstance())}
			>
				<IssueAdjustmentsAsync {...props} cloudId={cloudId} activationId={activationId} />
			</AnalyticsListener>
		);
	}

	return <IssueAdjustmentsAsync {...props} cloudId={cloudId} activationId={activationId} />;
};
